export default __webpack_public_path__ + "static/icono_usuaria2-5403ef7f2e88beea2c2dcda524e7992d.png";